import React from "react";
import AdminLayout from "../layouts/admin/AdminLayout";
import ErrorBoundaryWrapper from "../pages/error/ErrorBoundaryWrapper";
import PrivateRoute from "../components/PrivateRoute";
import RoleBasedRoute from "../components/RoleBasedRoute";

import { Dashboard, ForgotPassword, LoginOtp, Order, RetailerPriceBook, RetailerPriceBookCartPage, OTPVerification, Profile, ResetPasswordPage, WarehouseSelection, SupportTickets,OrderTablePage, OrderDetailsPage, AdminProduct, CartPage, SignUp, Login, SignupOtp, AdminTrackLoginDevices, AdminRetailer, AddRetailer, AdminPromo, AccountReceivable, Vendors, AddVendor, Permissions, AddSalesPerson, ViewSalesPerson, EditSalesPerson, RolesPermissionsPage, SalesLogin, Settings, ProductLicense, TermsAndConditions, PrivacyPolicy, Disclaimer, ReturnPolicy, Policies, AccountReceivableRetailer, RetailerTradeShow, RetailerTradeShowCart, SalesProfile, SalesOrder, SalesOrderTablePage, SalesOrderDetailsPage, SalesCartPage, SalesDashboard, AdminOrder, AdminOrderDetail, AdminDashboard, SalesOrderedItems, OrderedItems, AdminProfile, AccountReceivableSales, AdminNotifications,SalesCalenderPage, SalesCalenderViewPage, ProductCatalog, LandingPage, Products, RetailerRequest, AddUpdateRequest, ViewRetailerRequest, ContactUs, ContactUsRequestForm, SalesPolicies, RetailerPolicies, WebTermsConditions, WebPrivacyPolicy, WebSoftwareLicense, AdminCalender, DistributorStatusView, EpickSetting, DriverManagementLayout, DriverManagementMain, CreateRouteAutomatically, CreateRouteManually, SelectDriverVehicleStep, RouteOptimization, ManualrouteOptimize, ViewRoutesPage, DriverManagementSettings, ReceivableSetting, CancelledOrdersPage, DriverLogsPage, DriverRequestsPage, DriverVehicleActivityPage, Inventory, BulkUpdate, FuturePricing, SalesOrderConfirmation, SalesOrderConfirmationDetail, SalesReturnOrder, SalesReturnCartPage, OrderChecker, ReportsAnalytics, TradeshowManagement, CreateTradeshow, TradeshowSummaryView, SalesNoModulePermission, SalesOrderEntry, AdminOrderEntry  } from "./lazyComponents";
import { SalesTradeShow, SalesTradeShowCart, DashboardV1, DashboardV1TabPage, ProductV1, CustomerV1, VendorV1, SetupV1, PreBookList, PreBookForm, PreBookOrders, RetailerPreBookList, RetailerPreBookProducts, RetailerPreBookCartPage, SalesPreBookList, SalesPreBookProducts, SalesPreBookCartPage } from "./lazyComponents";
import { PriceBook, PriceBookCartPage } from "./lazyComponents";
import { ProductDetailPage } from "./lazyComponents";
import { MobileDashboardFullScreen } from "./lazyComponents";
import { ChatPage } from "./lazyComponents";
import { Navigate } from "react-router-dom";

// Check if user is logged in
const AuthCheck = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem('token');
  if (token) {
    // Get role from localStorage or default to retailer
    const role = localStorage.getItem('role') || 'retailer';
    const dashboardPath = role === 'sales' ? '/sales/dashboard' : role === 'distributor' ? '/admin/dashboard-v1?tab=orders' : '/retailer/dashboard';
    return <Navigate to={dashboardPath} replace />;
  }
  return <>{children}</>;
};

// Public routes - accessible without authentication
export const publicRoutes = [
  {
    path: "/",
    element: <AuthCheck><LandingPage /></AuthCheck>,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/landing",
    element: <LandingPage />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/product/:itemNumber",
    element: <ProductDetailPage />,
  },
  {
    path: "/contact-us",
    element: <ContactUsRequestForm />,
  },
  {
    path: "/signup",
    element: <SignUp />,
    // errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/signupOtp",
    element: <SignupOtp />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/loginPassword",
    element: <Login />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/login",
    element: <LoginOtp />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/otp-verification",
    element: <OTPVerification />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/sales-login",
    element: <SalesLogin />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/privacy-policy",
    element: <WebPrivacyPolicy />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/terms-conditions",
    element: <WebTermsConditions />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/software-license",
    element: <WebSoftwareLicense />,
    errorElement: <ErrorBoundaryWrapper />,
  },
  
];

// Retailer routes - only accessible to retailers
export const retailerRoutes = [
  {
    path: "/retailer",
    element: (
      <PrivateRoute>
        <RoleBasedRoute path="/retailer/dashboard">
          <AdminLayout />
        </RoleBasedRoute>
      </PrivateRoute>
    ),
    children: [
      {
        errorElement: <ErrorBoundaryWrapper />,
        children: [
          {
            path: "dashboard/",
            element: (
              <RoleBasedRoute path="/retailer/dashboard">
                <Dashboard />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order",
            element: (
              <RoleBasedRoute path="/retailer/order">
                <Order />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book",
            element: (
              <RoleBasedRoute path="/retailer/pre-book">
                <RetailerPreBookList />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book/:id",
            element: (
              <RoleBasedRoute path="/retailer/pre-book/:id">
                <RetailerPreBookProducts />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book/:id/cart",
            element: (
              <RoleBasedRoute path="/retailer/pre-book/:id/cart">
                <RetailerPreBookCartPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pricebook",
            element: (
              <RoleBasedRoute path="/retailer/pricebook">
                <RetailerPriceBook />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pricebook/cart",
            element: (
              <RoleBasedRoute path="/retailer/pricebook/cart">
                <RetailerPriceBookCartPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "orders/history",
            element: (
              <RoleBasedRoute path="/retailer/orders/history">
                <OrderTablePage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order/history",
            element: (
              <RoleBasedRoute path="/retailer/order">
                <OrderTablePage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order/details/:orderId",
            element: (
              <RoleBasedRoute path="/retailer/order">
                <OrderDetailsPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "ordered-items",
            element: (
              <RoleBasedRoute path="/retailer/ordered-items">
                <OrderedItems />
              </RoleBasedRoute>
            ),
          },
          {
            path: "cart",
            element: (
              <RoleBasedRoute path="/retailer/cart">
                <CartPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "policies",
            element: (
              <RoleBasedRoute path="/retailer/policies">
                <RetailerPolicies />  
              </RoleBasedRoute>
            ),
          },
          {
            path: "promo",
            element: (
              <RoleBasedRoute path="/retailer/promo">
                <div>Promo Page</div>
              </RoleBasedRoute>
            ),
          },
          {
            path: "account",
            element: (
              <RoleBasedRoute path="/retailer/account">
                <AccountReceivableRetailer />
              </RoleBasedRoute>
            ),
          },
          
          {
            path: "licence",
            element: (
              <RoleBasedRoute path="/retailer/licence">
                <ProductLicense />
              </RoleBasedRoute>
            ),
          },
          {
            path: "profile",
            element: (
              <RoleBasedRoute path="/retailer/profile">
                <Profile />
              </RoleBasedRoute>
            ),
          },
          {
            path: "terms-and-conditions",
            element: (
              <RoleBasedRoute path="/retailer/terms-and-conditions">
                <TermsAndConditions />
              </RoleBasedRoute>
            ),
          },
          {
            path: "privacy-policy",
            element: (
              <RoleBasedRoute path="/retailer/privacy-policy">
                <PrivacyPolicy />
              </RoleBasedRoute>
            ),
          },
          {
            path: "disclaimer",
            element: (
              <RoleBasedRoute path="/retailer/disclaimer">
                <Disclaimer />
              </RoleBasedRoute>
            ),
          },
          {
            path: "contact",
            element: (
              <RoleBasedRoute path="/retailer/contact">
                <ContactUs />
              </RoleBasedRoute>
            ),
          },
          {
            path: "return-policy",
            element: (
              <RoleBasedRoute path="/retailer/return-policy">
                <ReturnPolicy />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product-catalog",
            element: (
              <RoleBasedRoute path="/retailer/product-catalog">
                <ProductCatalog />
              </RoleBasedRoute>
            ),
          },
          {
            path: "trade-show",
            element: (
              <RoleBasedRoute path="/retailer/trade-show">
                <RetailerTradeShow />
              </RoleBasedRoute>
            ),
          },
          {
            path: "trade-show/cart",
            element: (
              <RoleBasedRoute path="/retailer/trade-show/cart">
                <RetailerTradeShowCart />
              </RoleBasedRoute>
            ),
          },
          {
            path: "chat",
            element: (
              <RoleBasedRoute path="/retailer/chat">
                <ChatPage />
              </RoleBasedRoute>
            ),
          },

        ],
      },
    ],
  },
];

// Admin routes - only accessible to admins
export const adminRoutes = [
  {
    // Full screen, deliberately outside AdminLayout: no sidebar or navbar, so the categories,
    // the step being edited and the phone preview all fit at once. Opened in its own tab from
    // Promo & Marketing, which is why it is a top-level path rather than a child of /admin.
    path: "/mobile-dashboard",
    element: (
      <PrivateRoute>
        <RoleBasedRoute path="/admin/promo">
          <MobileDashboardFullScreen />
        </RoleBasedRoute>
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/admin",
    element: (
      <PrivateRoute>
        <RoleBasedRoute path="/admin/dashboard">
          <AdminLayout />
        </RoleBasedRoute>
      </PrivateRoute>
    ),
    children: [
      {
        errorElement: <ErrorBoundaryWrapper />,
        children: [
          {
            path: "dashboard/",
            element: (
              <RoleBasedRoute path="/admin/dashboard">
                <AdminDashboard />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailers",
            element: (
              <RoleBasedRoute path="/admin/retailers">
                <AdminRetailer />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer/add",
            element: (
              <RoleBasedRoute path="/admin/retailer/add">
                <AddRetailer />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer/edit/:customerId",
            element: (
              <RoleBasedRoute path="/admin/retailer/edit/:customerId">
                <AddRetailer />
              </RoleBasedRoute>
            ),
          },
          {
            path: "products",
            element: (
              <RoleBasedRoute path="/admin/products">
                <AdminProduct />
              </RoleBasedRoute>
            ),
          },
          {
            path: "products/bulk-update",
            element: (
              <RoleBasedRoute path="/admin/products/bulk-update">
                <BulkUpdate />
              </RoleBasedRoute>
            ),
          },
          {
            path: "products/future-pricing",
            element: (
              <RoleBasedRoute path="/admin/products/future-pricing">
                <FuturePricing />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product/add",
            element: (
              <RoleBasedRoute path="/admin/product/add">
                <Inventory />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product/edit/:itemNumber",
            element: (
              <RoleBasedRoute path="/admin/product/edit/:itemNumber">
                <Inventory />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order",
            element: (
              <RoleBasedRoute path="/admin/order">
                <AdminOrder />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order-entry",
            element: (
              <RoleBasedRoute path="/admin/order-entry">
                <AdminOrderEntry />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order/details/:orderId",
            element: (
              <RoleBasedRoute path="/admin/order/details/:orderId">
                <AdminOrderDetail />
              </RoleBasedRoute>
            ),
          },
          {
            path: "account",
            element: (
              <RoleBasedRoute path="/admin/account">
                <AccountReceivable />
              </RoleBasedRoute>
            ),
          },
          {
            path: "high-demand",
            element: (
              <RoleBasedRoute path="/admin/high-demand">
                <div>High-demand Products</div>
              </RoleBasedRoute>
            ),
          },
          {
            path: "vendors",
            element: (
              <RoleBasedRoute path="/admin/vendors">
                <Vendors />
              </RoleBasedRoute>
            ),
          },
          {
            path: "vendor/add",
            element: (
              <RoleBasedRoute path="/admin/vendor/add">
                <AddVendor />
              </RoleBasedRoute>
            ),
          },
          {
            path: "vendor/edit/:vendorId",
            element: (
              <RoleBasedRoute path="/admin/vendor/edit/:vendorId">
                <AddVendor />
              </RoleBasedRoute>
            ),
          },
          {
            path: "reports",
            element: (
              <RoleBasedRoute path="/admin/reports">
                <div>Reports</div>
              </RoleBasedRoute>
            ),
          },
          {
            path: "support-tickets",
            element: (
              <RoleBasedRoute path="/admin/support-tickets">
                <SupportTickets />
              </RoleBasedRoute>
            ),
          },
          {
            path: "promo",
            element: (
              <RoleBasedRoute path="/admin/promo">
                <AdminPromo />
              </RoleBasedRoute>
            ),
          },  
          {
            path: "reports-analytics",
            element: (
              <RoleBasedRoute path="/admin/reports-analytics">
                <ReportsAnalytics />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book",
            element: (
              <RoleBasedRoute path="/admin/pre-book">
                <PreBookList />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book/create",
            element: (
              <RoleBasedRoute path="/admin/pre-book/create">
                <PreBookForm />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book/:id/edit",
            element: (
              <RoleBasedRoute path="/admin/pre-book/:id/edit">
                <PreBookForm />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book/:id/orders",
            element: (
              <RoleBasedRoute path="/admin/pre-book/:id/orders">
                <PreBookOrders />
              </RoleBasedRoute>
            ),
          },
          {
            path: "tradeshow-management",
            element: (
              <RoleBasedRoute path="/admin/tradeshow-management">
                <TradeshowManagement />
              </RoleBasedRoute>
            ),
          },
          {
            path: "tradeshow-management/create",
            element: (
              <RoleBasedRoute path="/admin/tradeshow-management/create">
                <CreateTradeshow />
              </RoleBasedRoute>
            ),
          },
          {
            path: "tradeshow-management/:id/edit",
            element: (
              <RoleBasedRoute path="/admin/tradeshow-management/:id/edit">
                <CreateTradeshow />
              </RoleBasedRoute>
            ),
          },
          {
            path: "tradeshow-management/:id/summary",
            element: (
              <RoleBasedRoute path="/admin/tradeshow-management/:id/summary">
                <TradeshowSummaryView />
              </RoleBasedRoute>
            ),
          },
          {
            path: "track-login-devices",
            element: (
              <RoleBasedRoute path="/admin/track-login-devices">
                <AdminTrackLoginDevices />
              </RoleBasedRoute>
            ),
          },
          {
            path: "purchase-orders",
            element: (
              <RoleBasedRoute path="/admin/purchase-orders">
                <div>Purchase Orders & Receiving</div>
              </RoleBasedRoute>
            ),
          },
          {
            path: "back-office",
            element: (
              <RoleBasedRoute path="/admin/back-office">
                <div>Back Office</div>
              </RoleBasedRoute>
            ),
          },
          {
            path: "permissions",
            element: (
              <RoleBasedRoute path="/admin/permissions">
                <Permissions />
              </RoleBasedRoute>
            ),
          },
          {
            path: "permissions/add",
            element: (
              <RoleBasedRoute path="/admin/permissions/add">
                <AddSalesPerson />
              </RoleBasedRoute>
            ),
          },

          {
            path: "permissions/view/:id",
            element: (
              <RoleBasedRoute path="/admin/permissions/view/:id">
                <ViewSalesPerson />
              </RoleBasedRoute>
            ),
          },
          {
            path: "permissions/edit/:id",
            element: (
              <RoleBasedRoute path="/admin/permissions/edit/:id">
                <EditSalesPerson />
              </RoleBasedRoute>
            ),
          },
          {
            path: "permissions/roles/:id",
            element: (
              <RoleBasedRoute path="/admin/permissions/roles/:id">
                <RolesPermissionsPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "settings",
            element: (
              <RoleBasedRoute path="/admin/settings">
                <Settings />
              </RoleBasedRoute>
            ),
          },
          {
            path: "terms-and-conditions",
            element: (
              <RoleBasedRoute path="/admin/terms-and-conditions">
                <TermsAndConditions />
              </RoleBasedRoute>
            ),
          },    
          {
            path: "privacy-policy",
            element: (
              <RoleBasedRoute path="/admin/privacy-policy">
                <PrivacyPolicy />
              </RoleBasedRoute>
            ),
          },    
          {
            path: "disclaimer",
            element: (
              <RoleBasedRoute path="/admin/disclaimer">
                <Disclaimer />
              </RoleBasedRoute>
            ),
          },    
          {
            path: "return-policy",
            element: (
              <RoleBasedRoute path="/admin/return-policy">
                <ReturnPolicy />
              </RoleBasedRoute>
            ),
          },  
          {
            path: "policies",
            element: (
              <RoleBasedRoute path="/admin/policies">
                <Policies />
              </RoleBasedRoute>
            ),
          },  
       
          {
            path: "profile",
            element: (
              <RoleBasedRoute path="/admin/profile">
                <AdminProfile />
              </RoleBasedRoute>
            ),
          },  
          {
            path: "notifications",
            element: (
              <RoleBasedRoute path="/admin/notifications">
                <AdminNotifications />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer-requests",
            element: (
              <RoleBasedRoute path="/admin/retailer-requests">
                <RetailerRequest />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer-requests/add",
            element: (
              <RoleBasedRoute path="/admin/retailer-requests/add">
                <AddUpdateRequest />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer-requests/edit/:id",
            element: (
              <RoleBasedRoute path="/admin/retailer-requests/edit/:id">
                <AddUpdateRequest />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer-requests/view/:id",
            element: (
              <RoleBasedRoute path="/admin/retailer-requests/view/:id">
                <ViewRetailerRequest />
              </RoleBasedRoute>
            ),
          },
          {
            path: "calender",
            element: (
              <RoleBasedRoute path="/admin/calender">
                <AdminCalender />
              </RoleBasedRoute>
            ),
          },
          {
            path: "calender/view",
            element: (
              <RoleBasedRoute path="/admin/calender/view">
                <DistributorStatusView />
              </RoleBasedRoute>
            ),
          },
          {
            path: "e-pick-settings",
            element: (
              <RoleBasedRoute path="/admin/e-pick-settings">
                <EpickSetting />
              </RoleBasedRoute>
            ),
          },
          {
           path: "dashboard-v1",
            element: (
              <RoleBasedRoute path="/admin/dashboard-v1">
                <DashboardV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "call-list",
            element: (
              <RoleBasedRoute path="/admin/call-list">
                <DashboardV1TabPage tabKey="call-list" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "msa",
            element: (
              <RoleBasedRoute path="/admin/msa">
                <DashboardV1TabPage tabKey="msa" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "ar-entry",
            element: (
              <RoleBasedRoute path="/admin/ar-entry">
                <DashboardV1TabPage tabKey="ar-entry" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "account-payable",
            element: (
              <RoleBasedRoute path="/admin/account-payable">
                <DashboardV1TabPage tabKey="account-payable" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "day-close",
            element: (
              <RoleBasedRoute path="/admin/day-close">
                <DashboardV1TabPage tabKey="day-close" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "create-po",
            element: (
              <RoleBasedRoute path="/admin/create-po">
                <DashboardV1TabPage tabKey="create-po" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "stamp-entry",
            element: (
              <RoleBasedRoute path="/admin/stamp-entry">
                <DashboardV1TabPage tabKey="stamp-entry" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product-v1",
            element: (
              <RoleBasedRoute path="/admin/product-v1">
                <ProductV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "customer-v1",
            element: (
              <RoleBasedRoute path="/admin/customer-v1">
                <CustomerV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "vendor-v1",
            element: (
              <RoleBasedRoute path="/admin/vendor-v1">
                <VendorV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "setup-v1",
            element: (
              <RoleBasedRoute path="/admin/setup-v1">
                <SetupV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "driver-management",
            element: (
              <RoleBasedRoute path="/admin/driver-management">
                <DriverManagementLayout />
              </RoleBasedRoute>
            ),
            children: [
              {
                index: true,
                element: <DriverManagementMain />,
              },
              {
                path: "drivers",
                element: <DriverManagementMain />,
              },
              {
                path: "vehicles",
                element: <DriverManagementMain />,
              },
              {
                path: "create-route-automatic",
                element: <CreateRouteAutomatically />,
              },
              {
                path: "create-route-manual",
                element: <CreateRouteManually />,
              },
              {
                path: "select-driver-vehicle",
                element: <SelectDriverVehicleStep />,
              },
              {
                path: "route-optimization",
                element: <RouteOptimization />,
              },
              {
                path: "manual-route-optimize",
                element: <ManualrouteOptimize />,
              },
              {
                path: "view-route",
                element: <ViewRoutesPage />,
              },
              {
                path: "cancelled-orders",
                element: <CancelledOrdersPage />,
              },
              {
                path: "logs",
                element: <DriverLogsPage />,
              },
              {
                path: "driver-requests",
                element: <DriverRequestsPage />,
              },
              {
                path: "activity",
                element: <DriverVehicleActivityPage />,
              },
              {
                path: "settings",
                element: <DriverManagementSettings />,
              },
            ],
          },
          {
  path: "receivable-settings",
  element: (
<RoleBasedRoute path="/admin/receivable-settings">
<ReceivableSetting />
</RoleBasedRoute>
  ),
},
          {
            path: "chat",
            element: (
              <RoleBasedRoute path="/admin/chat">
                <ChatPage />
              </RoleBasedRoute>
            ),
          },
        ],
      },
    ],
  },
];

// Sales routes - only accessible to sales
export const salesRoutes = [
  {
    path: "/sales",
    element: (
      <PrivateRoute>
        <RoleBasedRoute path="/sales/dashboard">
          <AdminLayout />
        </RoleBasedRoute>
      </PrivateRoute> 
    ),
    children: [
      {
        errorElement: <ErrorBoundaryWrapper />,
        children: [
          {
            path: "dashboard/", 
            element: (
              <RoleBasedRoute path="/sales/dashboard">
                <SalesDashboard />
              </RoleBasedRoute>
            ),
          }, 
          {
            path: "order",
            element: (
              <RoleBasedRoute path="/sales/order">
                <SalesOrder />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book",
            element: (
              <RoleBasedRoute path="/sales/pre-book">
                <SalesPreBookList />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book/:id",
            element: (
              <RoleBasedRoute path="/sales/pre-book/:id">
                <SalesPreBookProducts />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book/:id/cart",
            element: (
              <RoleBasedRoute path="/sales/pre-book/:id/cart">
                <SalesPreBookCartPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pricebook",
            element: (
              <RoleBasedRoute path="/sales/pricebook">
                <PriceBook />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pricebook/cart",
            element: (
              <RoleBasedRoute path="/sales/pricebook/cart">
                <PriceBookCartPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "trade-show",
            element: (
              <RoleBasedRoute path="/sales/trade-show">
                <SalesTradeShow />
              </RoleBasedRoute>
            ),
          },
          {
            path: "trade-show/cart",
            element: (
              <RoleBasedRoute path="/sales/trade-show/cart">
                <SalesTradeShowCart />
              </RoleBasedRoute>
            ),
          },
          {
            path: "return-order",
            element: (
              <RoleBasedRoute path="/sales/return-order">
                <SalesReturnOrder />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order-confirmation",
            element: (
              <RoleBasedRoute path="/sales/order-confirmation">
                <SalesOrderConfirmation />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order-confirmation/:orderId",
            element: (
              <RoleBasedRoute path="/sales/order-confirmation/:orderId">
                <SalesOrderConfirmationDetail />
              </RoleBasedRoute>
            ),
          },
          {
            path: "ordered-items",
            element: (
              <RoleBasedRoute path="/sales/ordered-items">
                <SalesOrderedItems />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order/history",
            element: (
              <RoleBasedRoute path="/sales/order/history">
                <SalesOrderTablePage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "orders/history",
            element: (
              <RoleBasedRoute path="/sales/orders/history">
                <SalesOrderTablePage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order/details/:orderId",
            element: (
              <RoleBasedRoute path="/sales/order/details/:orderId">
                <SalesOrderDetailsPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "cart",
            element: (
              <RoleBasedRoute path="/sales/cart">
                <SalesCartPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "return-cart",
            element: (
              <RoleBasedRoute path="/sales/return-cart">
                <SalesReturnCartPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order-checker",
            element: (
              <RoleBasedRoute path="/sales/order-checker">
                <OrderChecker />
              </RoleBasedRoute>
            ),
          },
          {
            path: "order-entry",
            element: (
              <RoleBasedRoute path="/sales/order-entry">
                <SalesOrderEntry />
              </RoleBasedRoute>
            ),
          },
          {
            path: "no-permission",
            element: (
              <RoleBasedRoute path="/sales/no-permission">
                <SalesNoModulePermission />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailers",
            element: (
              <RoleBasedRoute path="/sales/retailers">
                <CustomerV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer/add",
            element: (
              <RoleBasedRoute path="/sales/retailer/add">
                <AddRetailer />
              </RoleBasedRoute>
            ),
          },
          {
            path: "retailer/edit/:customerId",
            element: (
              <RoleBasedRoute path="/sales/retailer/edit/:customerId">
                <AddRetailer />
              </RoleBasedRoute>
            ),
          },
          {
            path: "calender",
            element: (
              <RoleBasedRoute path="/sales/calender">
                <SalesCalenderPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "calender/view",
            element: (
              <RoleBasedRoute path="/sales/calender/view">
                <SalesCalenderViewPage />
              </RoleBasedRoute>
            ),
          },
          {
            path: "track-login-devices",
            element: (
              <RoleBasedRoute path="/sales/track-login-devices">
                <AdminTrackLoginDevices />
              </RoleBasedRoute>
            ),
          },
          {
            path: "tracklogindevice",
            element: (
              <RoleBasedRoute path="/sales/tracklogindevice">
                <AdminTrackLoginDevices />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product",
            element: (
              <RoleBasedRoute path="/sales/product">
                <ProductV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product/future-pricing",
            element: (
              <RoleBasedRoute path="/sales/product/future-pricing">
                <FuturePricing />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product/bulk-update",
            element: (
              <RoleBasedRoute path="/sales/product/bulk-update">
                <BulkUpdate />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product/add",
            element: (
              <RoleBasedRoute path="/sales/product/add">
                <Inventory />
              </RoleBasedRoute>
            ),
          },
          {
            path: "product/edit/:itemNumber",
            element: (
              <RoleBasedRoute path="/sales/product/edit/:itemNumber">
                <Inventory />
              </RoleBasedRoute>
            ),
          },
          {
            path: "vendor",
            element: (
              <RoleBasedRoute path="/sales/vendor">
                <VendorV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "vendor/add",
            element: (
              <RoleBasedRoute path="/sales/vendor/add">
                <AddVendor />
              </RoleBasedRoute>
            ),
          },
          {
            path: "vendor/edit/:vendorId",
            element: (
              <RoleBasedRoute path="/sales/vendor/edit/:vendorId">
                <AddVendor />
              </RoleBasedRoute>
            ),
          },
          // Pre-Book management (create / edit / delete, orders approve / reject) — the admin
          // screens, for sales users given the "Pre-Book Management" permission
          {
            path: "pre-book-management",
            element: (
              <RoleBasedRoute path="/sales/pre-book-management">
                <PreBookList />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book-management/create",
            element: (
              <RoleBasedRoute path="/sales/pre-book-management/create">
                <PreBookForm />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book-management/:id/edit",
            element: (
              <RoleBasedRoute path="/sales/pre-book-management/:id/edit">
                <PreBookForm />
              </RoleBasedRoute>
            ),
          },
          {
            path: "pre-book-management/:id/orders",
            element: (
              <RoleBasedRoute path="/sales/pre-book-management/:id/orders">
                <PreBookOrders />
              </RoleBasedRoute>
            ),
          },
          {
            path: "epick",
            element: (
              <RoleBasedRoute path="/sales/epick">
                <EpickSetting />
              </RoleBasedRoute>
            ),
          },
          {
            path: "account",
            element: (
              <RoleBasedRoute path="/sales/account">
                <AccountReceivableSales />
              </RoleBasedRoute>
            ),
          },
          {
            path: "ar-entry",
            element: (
              <RoleBasedRoute path="/sales/ar-entry">
                <DashboardV1TabPage tabKey="ar-entry" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "account-payable",
            element: (
              <RoleBasedRoute path="/sales/account-payable">
                <DashboardV1TabPage tabKey="account-payable" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "create-po",
            element: (
              <RoleBasedRoute path="/sales/create-po">
                <DashboardV1TabPage tabKey="create-po" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "call-list",
            element: (
              <RoleBasedRoute path="/sales/call-list">
                <DashboardV1TabPage tabKey="call-list" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "reports-analytics",
            element: (
              <RoleBasedRoute path="/sales/reports-analytics">
                <ReportsAnalytics />
              </RoleBasedRoute>
            ),
          },
          {
            path: "msa",
            element: (
              <RoleBasedRoute path="/sales/msa">
                <DashboardV1TabPage tabKey="msa" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "day-close",
            element: (
              <RoleBasedRoute path="/sales/day-close">
                <DashboardV1TabPage tabKey="day-close" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "stamp-entry",
            element: (
              <RoleBasedRoute path="/sales/stamp-entry">
                <DashboardV1TabPage tabKey="stamp-entry" />
              </RoleBasedRoute>
            ),
          },
          {
            path: "setup-v1",
            element: (
              <RoleBasedRoute path="/sales/setup-v1">
                <SetupV1 />
              </RoleBasedRoute>
            ),
          },
          {
            path: "promo",
            element: (
              <RoleBasedRoute path="/sales/promo">
                <AdminPromo />
              </RoleBasedRoute>
            ),
          },
          {
            path: "notifications",
            element: (
              <RoleBasedRoute path="/sales/notifications">
                <AdminNotifications />
              </RoleBasedRoute>
            ),
          },

          {
            path: "driver-management",
            element: (
              <RoleBasedRoute path="/sales/driver-management">
                <DriverManagementLayout />
              </RoleBasedRoute>
            ),
            children: [
              {
                index: true,
                element: <DriverManagementMain />,
              },
              {
                path: "drivers",
                element: <DriverManagementMain />,
              },
              {
                path: "vehicles",
                element: <DriverManagementMain />,
              },
              {
                path: "create-route-automatic",
                element: <CreateRouteAutomatically />,
              },
              {
                path: "create-route-manual",
                element: <CreateRouteManually />,
              },
              {
                path: "select-driver-vehicle",
                element: <SelectDriverVehicleStep />,
              },
              {
                path: "route-optimization",
                element: <RouteOptimization />,
              },
              {
                path: "manual-route-optimize",
                element: <ManualrouteOptimize />,
              },
              {
                path: "view-route",
                element: <ViewRoutesPage />,
              },
              {
                path: "cancelled-orders",
                element: <CancelledOrdersPage />,
              },
              {
                path: "logs",
                element: <DriverLogsPage />,
              },
              {
                path: "driver-requests",
                element: <DriverRequestsPage />,
              },
              {
                path: "activity",
                element: <DriverVehicleActivityPage />,
              },
              {
                path: "settings",
                element: <DriverManagementSettings />,
              },
            ],
          },
          {
            path: "policies",
            element: (
              <RoleBasedRoute path="/sales/policies">
                <SalesPolicies />
              </RoleBasedRoute>
            ),
          },
          {
            path: "profile",
            element: (
              <RoleBasedRoute path="/sales/profile">
                <SalesProfile />
              </RoleBasedRoute>
            ),
          },
          {
            path: "chat",
            element: (
              <RoleBasedRoute path="/sales/chat">
                <ChatPage />
              </RoleBasedRoute>
            ),
          },

            ],
      },
    ],
  },
];

// Shared routes - accessible to both roles
export const sharedRoutes = [
  {
    path: "/warehouse-selection",
    element: (
      <PrivateRoute>
        <RoleBasedRoute path="/warehouse-selection">
          <WarehouseSelection />
        </RoleBasedRoute>
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundaryWrapper />,
  },
];

// Combine all routes
export const routes = [
  ...publicRoutes,
  ...retailerRoutes,
  ...adminRoutes,
  ...salesRoutes,
  ...sharedRoutes,
];
